// Mobile 框架未支持配置化
export const MOBILE_MONTHLY_PAGE_CONFIG = {
  showUnconfiguredPage: true,
  unconfiguredComponentName: 'MobileMonthly'
};